// @flow

import React from "react";
import classNames from "classnames";

import {
  Popover as ReakitPopover,
  PopoverDisclosure as ReakitPopoverDisclosure,
  PopoverArrow as ReakitPopoverArrow,
} from "reakit/Popover";

import "./popover.css";

export { usePopoverState } from "reakit/Popover";

export const Popover = ({ children, className, ...props }: *) => {
  return (
    <div className={classNames("q-Popover", className)} {...props}>
      {children}
    </div>
  );
};

export const PopoverReference = ({ children, className, ...props }: *) => (
  <ReakitPopoverDisclosure
    as="div"
    className={classNames("q-Popover__reference", className)}
    {...props}
  >
    {disclosureProps =>
      React.cloneElement(
        React.Children.only(<div>{children}</div>),
        disclosureProps
      )
    }
  </ReakitPopoverDisclosure>
);

export const PopoverTooltip = ({
  arrow = true,
  className,
  children,
  ...props
}: *) => (
  <ReakitPopover
    aria-label="lorem ipsum"
    tabIndex={0}
    {...props}
    className={classNames("q-Popover__tooltip", className)}
  >
    {arrow && <ReakitPopoverArrow {...props} className="q-Popover__arrow" />}
    {children}
  </ReakitPopover>
);
